import firebase from 'firebase';

// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDXZ7Oi7kBNMxcEleNwbhaCO2hssnW3r_M",
  authDomain: "slack-clone-ba717.firebaseapp.com",
  projectId: "slack-clone-ba717",
  storageBucket: "slack-clone-ba717.appspot.com",
  messagingSenderId: "425503282499",
  appId: "1:425503282499:web:0fb3e476f1e8bcb4948bf6",
  measurementId: "G-2TEFLSVH8R",
};

const firebaseApp = firebase.initializeApp(firebaseConfig);
const db = firebaseApp.firestore();
const auth = firebase.auth();
const provider = new firebase.auth.GoogleAuthProvider();

export { auth, provider };
export default db;
